import { React } from "react";
import "./Burger.css";

const Burger = (props) => {
  return props.windowWidth < 1024 ? (
    <div className="burger">
      <div
        className={
          props.menuIsOpen
            ? "burger-menu-button burger-menu-open"
            : "burger-menu-button"
        }
        onClick={props.handleMenuChange}
      >
        <span className="bar-1"></span>
        <span className="bar-2"></span>
      </div>
    </div>
  ) : null;
};

export default Burger;
